import { NgModule } from "@angular/core";

import { CalloutComponent } from "./callout.component";

@NgModule({
  imports: [CalloutComponent],
  exports: [CalloutComponent],
})
export class CalloutModule {}
